import {CreditCardInfo, DisplayCreditCardExpireDate, ErrorMessagesForNewCreditCardInput, ErrorMessagesForPaymentMethodInput, MyCreditCardInfo, NewCreditCardInputInfo, SecurityCodeForMyCreditCard, UsingMyCreditCardInfo} from '../../../../Props/ContractInputInfo'
import dayjs from 'dayjs'
import {Optional} from '../../../../../Common/TypeHelper'
import {MBMemberRadio} from '../../../Atoms/MBMemberRadio'
import {CardInformationDiv} from './CardInformationDiv'
import React from 'react'
import {ColumnFlexContainer, FlexContainer} from '../../../Atoms/Containers'
import {Spacer} from '../../../../../Common/Components/Spacer'
import {MBContentBodyDivider} from '../../../Atoms/Dividers'
import {ErrorDisplay} from '../../../Molecules/ErrorsAndAlert/ErrorDisplay'
import {MBContentBodyItemWarningMessageTypography} from '../../../Atoms/Typographies'
import {MBDeleteButton} from '../../../Atoms/Buttons'
import {ExpiredCardBadge, MBInUseBadge} from '../../../Atoms/Badges'
import {NewCreditCardInputComponent, SecurityCodeInputForm} from './NewCreditCardInputComponent'
import {PIMStack} from '../../../Atoms/Layouts/Bases/PIMStack'

export type SelectCreditCardRadioListForProps = {
  myCreditCardInfoList: UsingMyCreditCardInfo[]
  creditCardInfo: CreditCardInfo
  nextContractStartDate_YYYYMMDD?: string
  newCreditCardRegisterDisable: boolean
  errorMessages: ErrorMessagesForPaymentMethodInput
  onChangeInputDetailInfo: (changeInputDetailInfo: CreditCardInfo) => void
  onDeleteCardButtonClick?: (deleteCardInfo: MyCreditCardInfo) => void
}

export const SelectCreditCardRadioList =
  (props: SelectCreditCardRadioListForProps): JSX.Element => {

    return (
      <PIMStack spacing={'18px'} divider={<MBContentBodyDivider/>}>
        {
          props.myCreditCardInfoList.length !== 0 &&
          props.myCreditCardInfoList.map((myCreditCardInfo, i) => {
            const expired =
              isExpiredCreditCard(myCreditCardInfo.expireDate, props.nextContractStartDate_YYYYMMDD)
            const hasError =
              (props.errorMessages.errorMyCreditCardId === myCreditCardInfo.cardId)
              || (props.errorMessages.creditCardTypeErrors.length > 0)

            return (
              <div data-testid={`block-input-my-credit-card-information${i}`} key={i}>
                <ColumnFlexContainer>
                  <Spacer mb={'12px'}>
                    <FlexContainer alignItems={'baseline'} gap={'6px'}>
                      <div>
                        <MBMemberRadio
                          id={`my-credit-card-${i + 1}`}
                          name="payment1"
                          labelName={`登録済みクレジットカード${(i + 1)}`}
                          disabled={expired}
                          hasError={expired ? false : hasError}
                          isBoldLabel={true}
                          fontRemSize={1.2}
                          value={myCreditCardInfo.cardId}
                          onChange={(e): void => {
                            props.onChangeInputDetailInfo({
                              creditCardType: 'myCard',
                              myCreditCardInfo: {
                                selectedCardId: e.target.value,
                                securityCodeMap:
                                props.creditCardInfo.myCreditCardInfo.securityCodeMap,
                              },
                              newCreditCardInfo: props.creditCardInfo.newCreditCardInfo,
                            })
                          }}
                          checked={isCheckedMyCardId(props.creditCardInfo, myCreditCardInfo)}
                        />
                      </div>
                      <ColumnFlexContainer gap={'2px'}>
                        {
                          expired && <div><ExpiredCardBadge/></div>
                        }
                        {
                          myCreditCardInfo.isInUse && <div><MBInUseBadge/></div>
                        }
                      </ColumnFlexContainer>
                    </FlexContainer>
                  </Spacer>
                  {hasError && (
                    <Spacer ml={'28px'} my={'12px'}>
                      <ErrorDisplay
                        errors={hasError ? props.errorMessages.invalidCardErrors : []}
                      />
                    </Spacer>
                  )}
                  <CardInformationDiv disabled={expired}>
                    <FlexContainer alignItems={'baseline'}>
                      {myCreditCardInfo.cardNumber}
                      <DisplayCreditCardExpireDate expireDate={myCreditCardInfo.expireDate}/>
                    </FlexContainer>
                  </CardInformationDiv>
                  {
                    (
                      props.creditCardInfo.creditCardType === 'myCard' &&
                      myCreditCardInfo.cardId
                      === props.creditCardInfo.myCreditCardInfo.selectedCardId
                    ) &&
                    <Spacer ml={'10%'}>
                      <SecurityCodeInputForm
                        securityCode={
                          findSecurityCodeByCardId(
                            props.creditCardInfo.myCreditCardInfo.securityCodeMap,
                            myCreditCardInfo.cardId,
                          )?.securityCode || ''
                        }
                        errorMessages={
                          hasError
                            ? {
                              ...props.errorMessages,
                              creditCardSecurityCodeErrors: [],
                            }
                            : {
                              ...props.errorMessages,
                              invalidCardErrors: [],
                              creditCardSecurityCodeErrors: [],
                              myCreditCardSecurityCodeErrors: [],
                            }
                        }
                        onChangeInputSecurityCode={(value): void => {
                          const _securityCodeMap: SecurityCodeForMyCreditCard[] =
                            Object.assign(props.creditCardInfo.myCreditCardInfo.securityCodeMap)
                          const findCardIdInSecurityCodeMap =
                            findSecurityCodeByCardId(_securityCodeMap, myCreditCardInfo.cardId)
                          if (findCardIdInSecurityCodeMap) {
                            findCardIdInSecurityCodeMap.securityCode = value
                          }

                          props.onChangeInputDetailInfo({
                            creditCardType: 'myCard',
                            myCreditCardInfo: {
                              selectedCardId:
                              props.creditCardInfo.myCreditCardInfo.selectedCardId,
                              securityCodeMap: _securityCodeMap,
                            },
                            newCreditCardInfo: props.creditCardInfo.newCreditCardInfo,
                          })
                        }}
                      />
                    </Spacer>
                  }
                  {
                    !myCreditCardInfo.isInUse &&
                    <Spacer ml={'auto'} mr={'16px'} mt={'12px'}>
                      <MBDeleteButton
                        testId={`delete-button-${myCreditCardInfo.cardId}`}
                        onClick={(): void => {
                          if (props.onDeleteCardButtonClick) {
                            props.onDeleteCardButtonClick(myCreditCardInfo)
                          }
                        }}/>
                    </Spacer>
                  }
                </ColumnFlexContainer>
              </div>
            )
          })
        }

        <div data-testid={`block-input-new-credit-card`}>
          <FlexContainer>
            <MBMemberRadio
              id={`new-credit-card`}
              name="payment1"
              labelName={'新規クレジットカード'}
              isBoldLabel={true}
              fontRemSize={1.2}
              value={'newCard'}
              disabled={props.newCreditCardRegisterDisable}
              hasError={hasErrorForNewCreditCardRadioButton(
                props.errorMessages.creditCardTypeErrors,
                props.errorMessages.errorMyCreditCardId,
                props.errorMessages)}
              onChange={(): void => {
                props.onChangeInputDetailInfo({
                  creditCardType: 'newCard',
                  myCreditCardInfo: props.creditCardInfo.myCreditCardInfo,
                  newCreditCardInfo: props.creditCardInfo.newCreditCardInfo,
                })
              }}
              checked={props.creditCardInfo.creditCardType === 'newCard'}
            />

          </FlexContainer>
          {
            props.newCreditCardRegisterDisable &&
            <Spacer mt={'12px'} ml={'56px'}>
              <MBContentBodyItemWarningMessageTypography>
                クレジットカード情報の登録は5枚までとなります。新規クレジットカードを選択するためには、登録されたクレジットカード情報を削除してください。
              </MBContentBodyItemWarningMessageTypography>
            </Spacer>
          }
          {
            props.creditCardInfo.creditCardType === 'newCard' &&
            <NewCreditCardInputComponent
              newCreditCardInputInfo={props.creditCardInfo.newCreditCardInfo}
              errorMessages={props.errorMessages.errorMyCreditCardId === ''
                ? props.errorMessages
                : {
                  ...props.errorMessages,
                  invalidCardErrors: [],
                }
              }
              onChangeInputDetailInfo={
                (value: NewCreditCardInputInfo): void => {
                  props.onChangeInputDetailInfo({
                    creditCardType: 'newCard',
                    newCreditCardInfo: value,
                    myCreditCardInfo: props.creditCardInfo.myCreditCardInfo,
                  })
                }
              }
            />
          }
        </div>
      </PIMStack>
    )
  }

export const isExpiredCreditCard =
  (cardExpireDate_MMYYYY: string, nextContractStartDate_YYYYMMDD?: string): boolean => {
    const [expireMonth, expireYear] = cardExpireDate_MMYYYY.split('/')
    const expireDateString = `${expireYear}/${expireMonth}`
    const expireDate = dayjs(expireDateString).format('YYYY/MM')

    if (!nextContractStartDate_YYYYMMDD) {
      return expireDate < dayjs().format('YYYY/MM')
    }

    const [nextStartYear, nextStartMonth] = nextContractStartDate_YYYYMMDD.split('/')
    const nextDateString = `${nextStartYear}/${nextStartMonth}`

    return expireDate < dayjs(nextDateString).format('YYYY/MM')
  }

export const isCheckedMyCardId =
  (creditCardInfo: CreditCardInfo, myCreditCardInfo: MyCreditCardInfo): boolean => {
    if (creditCardInfo.creditCardType === 'myCard') {
      return (myCreditCardInfo.cardId === creditCardInfo.myCreditCardInfo.selectedCardId)
    }

    return false
  }

export const findSecurityCodeByCardId = (
  securityCodeMap: SecurityCodeForMyCreditCard[],
  cardId: string,
): Optional<SecurityCodeForMyCreditCard> => {

  return securityCodeMap.find(item => item.cardId === cardId)
}

const hasErrorForNewCreditCardRadioButton = (
  cardTypeErrorMessage: string[],
  errorMyCardId: string,
  newCardErrorMessages: ErrorMessagesForNewCreditCardInput): boolean => {
  const isInvalidCardError = (): boolean => {
    if (errorMyCardId === '') {
      return newCardErrorMessages.invalidCardErrors.length > 0
    }
    return false
  }

  return (
    isInvalidCardError() ||
    cardTypeErrorMessage.length > 0 ||
    newCardErrorMessages.creditCardNumberErrors.length > 0 ||
    newCardErrorMessages.creditCardExpireMonthErrors.length > 0 ||
    newCardErrorMessages.creditCardExpireYearErrors.length > 0 ||
    newCardErrorMessages.creditCardFutureExpireDateErrors.length > 0 ||
    newCardErrorMessages.creditCardHolderNameErrors.length > 0 ||
    newCardErrorMessages.creditCardSecurityCodeErrors.length > 0
  )
}
